import axios from 'axios';

export default function (context, {id, cb}) {
    context.commit('loading', true);
    axios({
        method: 'get',
        url: '/tourclient/api/giftCertificate?id='+id,
    }).then(({data}) => {
        let d = data.Certificate;
        if(cb) cb(d);
        context.commit('loading', false);
    }).catch(e => {
        context.commit('loading', false);
        context.dispatch('error', e, {root: true});
    })
}
